<template>
  <div class="row">
  	<div class="card col-12 mb-5" style="width: 18rem;">
      <div class="card-header text-center" v-if="mostrar_tiempo_restante">
        {{tiempo_restante_horas}} hrs.
      </div>
	  	<div class="card-body my-3 px-0 px-md-5 mx-md-5">
        <div v-bind:class="loading">
          <div class="d-flex justify-content-center">
            <div class="spinner-border m-5" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div v-bind:class="result">
          <div id="examenes_contestar" class="list-group">
            <a href="" v-for="examen of examenes" v-on:click.prevent="Abrir_Examen(examen)" class="list-group-item list-group-item-action">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{examen.nombre}}</h5>
                <small>{{examen.avance}} %</small>
              </div>
              <p class="mb-1">{{examen.descripcion}}</p>
              <small>
                <div class="progress">
                  <div class="progress-bar" role="progressbar" :aria-valuenow="examen.avance" aria-valuemin="0" aria-valuemax="100">
                    {{examen.avance}}%
                  </div>
                </div>
              </small>
            </a>
          </div>
          <!--
          <div class="col-12 text-center my-5 d-none">
            <button class="btn btn-success" v-on:click="Imprimir_Boleta_Examen">Imprimir Boleta de Exámen</button>
          </div>
          -->
        </div>
	  	</div>
	  </div>
  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode';
import {mapActions} from 'vuex';
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      examenes:[]
    }
  },
  methods:{
    Imprimir_Boleta_Examen(){
      if (localStorage.getItem("apikeySiepsBiologicasUanl")) {

          if (JSON.parse(localStorage.apikeySiepsBiologicasUanl).length>30) {
              var token   = VueJwtDecode.decode(JSON.parse(localStorage.apikeySiepsBiologicasUanl));
              var idsolicitud=token.data.idsolicitud;

              var completados=0;
              console.log(this.examenes.length);
              for (var i = 0; i < this.examenes.length; i++) {
                console.log(Number(this.examenes[i].avance));
                if (Number(this.examenes[i].avance)>=100) {
                  completados++;
                }
              }
              console.log(completados);
              if (completados>=3) {
                this.$router.push({name:'Imprimir_Boleta_Examen'});
              }else{
                alert('Debes completar las 3 pruebas');
              }

              //this.$router.push({name:'Imprimir_Boleta_Examen',params:{idsolicitud:idsolicitud}});
          }else{
            swal("Problemas para obtener tu información", "Favor de recargar la página", "error");
          }

      }else{
        swal("Problemas para obtener tu información", "Favor de recargar la página", "error");
      }
    },
    Consultar_Examenes(){
      console.log('Consultar_Examenes');
      var that = this;
      this.Cargando();
      this.$http.get('solicitudes/mis/examenes')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        this.Listo();
        if (respuestaJson.resp=='Excelente') {
          this.examenes=respuestaJson.examenes;
          console.log(this.mostrar_tiempo_restante);
          var completados=0;
          for (var i = 0; i < this.examenes.length; i++) {
            if (Number(this.examenes[i].avance)>=100) {
              completados++;
            }
          }
          /*
          if (completados>=3) {
            this.$router.push({name:'Imprimir_Boleta_Examen'});
          }else
          */
          if (this.mostrar_tiempo_restante==false) {
            this.Mostrar_Tiempo_Restante(true);
            if (Number(respuestaJson.tiempo_restante)==0) {
              console.log('Sin tiempo');
              this.$router.push({name:'Login'});
              swal("El tiempo se terminó", "La prueba tiene un tiempo de 3 horas máximo", "error");
            }else{
              this.Iniciar_Tiempo_Restante(Number(respuestaJson.tiempo_restante));
            }
          }
          $(document).ready(function(){
            $('#examenes_contestar').find('.progress-bar').each(function(i,element){
              $(element).width(Number(that.examenes[i].avance)+'%');
            });
          });
        }else{
          swal("¡Ups!",respuestaJson.resp, "error");
        }
      })
      .catch(error=>{
        this.Listo();
        swal("Favor de Intentar mas tarde", "Problemas para cargar los exámenes", "error");
      });
    },
    Abrir_Examen(examen){
      console.log(examen.abreviatura);
      if (examen.abreviatura=='entrevista') {
        this.$router.push({name:'entrevista'});
      }
      else if (examen.abreviatura=='dibujos') {
        this.$router.push({name:'dibujos'});
      }
      else if (examen.abreviatura=='terman') {
        this.$router.push({
          name:'terman_instrucciones',
          params:{
            serie:1
          }
        });
      }
      else{
        this.$router.push({name:examen.abreviatura+'_instrucciones'});
      }
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	},
    ...mapActions(['Mostrar_Tiempo_Restante','Iniciar_Tiempo_Restante'])
  },
  computed:{
    mostrar_tiempo_restante(){
      return this.$store.getters.getMostrar_Tiempo_Restante;
    },
    avance_total(){
      return this.$store.getters.getAvance_Total;
    },
    tiempo_restante(){
      return this.$store.getters.getTiempo_Restante;
    },
    tiempo_restante_horas(){
      return this.$store.getters.getTiempo_Restante_Horas;
    }
  },
  mounted(){
    this.Consultar_Examenes();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Examenes.vue